/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#australia[_ngcontent-%COMP%]{text-align:center}#ACT[_ngcontent-%COMP%], #NSW[_ngcontent-%COMP%], #NT[_ngcontent-%COMP%], #QLD[_ngcontent-%COMP%], #SA[_ngcontent-%COMP%], #TAS[_ngcontent-%COMP%], #VIC[_ngcontent-%COMP%], #WA[_ngcontent-%COMP%]{fill:#fff;stroke:#6d6d6d;stroke-width:1px;transition:fill}#australia[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:active{fill:#f1c400}"];
export { styles as styles };
